module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0204.bbc696d4.jpg";